import React from 'react';
import { Button } from 'js/components/main/LeaderboardButton/Button';
import { LocalPopup } from 'js/components/common/Popup';
import LeaveButton from './LeaveButton';
import style from './index.scss';
import classNames from '../../Details/classNames';

export const StayButton = ({ toggleLeavePopup, t, isInModal }) => {
    return <Button
        view='primary'
        variant='rounded'
        color='lbSuccess'
        size='large'
        onClick={toggleLeavePopup}
        className={classNames(style.button, style.stayButton, { [style.inModalButtonStyle]: isInModal })}>
        {t('playtech.mobile.system.casino-leaderboard.leaveRace.popup.button.stay')}
    </Button>;
};

export const popupClassNames = { inner: style.popupInner, header: style.popupHeader };

export default ({ toggleLeavePopup, leaderboardId, t, eventCountLimit, useTournament, trackLeaveEventClick }) => {
    const displayText = eventCountLimit ?
            useTournament ? 'playtech.mobile.system.casino-leaderboard.leaveRace.popup.eventsText.tournament' : 'playtech.mobile.system.casino-leaderboard.leaveRace.popup.eventsText'
            :
            useTournament ? 'playtech.mobile.system.casino-leaderboard.leaveRace.popup.nonEventsText.tournament' : 'playtech.mobile.system.casino-leaderboard.leaveRace.popup.nonEventsText';
    return (
    <LocalPopup onClose={toggleLeavePopup}
           className={style.popup}
           classNames={popupClassNames}
           iconType='lbLeaveRaceIconClose'>
        <div className={style.content}>
            <p className={style.title}>{t('playtech.mobile.system.casino-leaderboard.leaveRace.popup.title')}</p>
            <p>{t(displayText)}</p>
        </div>
        <div className={style.actions}>
            <LeaveButton {...{ leaderboardId, useTournament, trackLeaveEventClick }} shortText={true} isInModal={true}/>
            <StayButton {...{ toggleLeavePopup, t }} isInModal={true}/>
        </div>
    </LocalPopup>
);
};

